

import $ from 'jquery';
import Component from './component';
import createComponentFactory from '../createComponent';
import headerPanelNavItem from './headerPanelNavItem';
import { hideHeaderPanelAction } from '../action/headerPanelAction';


class HeaderPanel extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.$element = $(element);
    this.$close = this.$element.find('.js-headerPanel__close');

    this._handlePanelClose = this._handlePanelClose.bind(this);
  }

  _handlePanelClose(evt) {
    evt.preventDefault();

    this.channel.root.sendDownstream(hideHeaderPanelAction);
  }

  _addEvents() {
    this.$close.on('click', this._handlePanelClose);
  }

  _removeEvents() {
    this.$close.off('click', this._handlePanelClose);
  }

  didRegisterComponent() {
    this._addEvents();

    this.registerComponent('headerPanelNavItem', '.js-headerPanelNavItem', headerPanelNavItem);
  }

  didUnregisterComponent() {
    this._removeEvents();

    this.unregisterComponent('headerPanelNavItem');
  }
}


export default createComponentFactory(HeaderPanel);



// WEBPACK FOOTER //
// ./src/js/app/component/headerPanel.js